var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.79289 2.79289C4.04657 1.53921 5.84586 1 8 1H16C18.1541 1 19.9534 1.53921 21.2071 2.79289C22.4608 4.04657 23 5.84586 23 8V16C23 18.1541 22.4608 19.9534 21.2071 21.2071C19.9534 22.4608 18.1541 23 16 23H3C1.89772 23 1 22.1023 1 21V8C1 5.84586 1.53921 4.04657 2.79289 2.79289ZM4.20711 4.20711C3.46079 4.95343 3 6.15414 3 8V21H16C17.8459 21 19.0466 20.5392 19.7929 19.7929C20.5392 19.0466 21 17.8459 21 16V8C21 6.15414 20.5392 4.95343 19.7929 4.20711C19.0466 3.46079 17.8459 3 16 3H8C6.15414 3 4.95343 3.46079 4.20711 4.20711Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.5C6 8.94772 6.44772 8.5 7 8.5H17C17.5523 8.5 18 8.94772 18 9.5C18 10.0523 17.5523 10.5 17 10.5H7C6.44772 10.5 6 10.0523 6 9.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14.5C6 13.9477 6.44772 13.5 7 13.5H14C14.5523 13.5 15 13.9477 15 14.5C15 15.0523 14.5523 15.5 14 15.5H7C6.44772 15.5 6 15.0523 6 14.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.191d13b84a684f010c3f09f2c741178f.svg";
export { ForwardRef as ReactComponent };